import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEllipsisVertical = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	className: "ionicon",
	viewBox: "0 0 512 512",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 256,
			cy: 256,
			r: 48
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 256,
			cy: 416,
			r: 48
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 256,
			cy: 96,
			r: 48
		})
	]
});
export default SvgEllipsisVertical;
